import { Pipe, type PipeTransform } from '@angular/core';
import { NavigationItem } from '../interfaces/navigationList.interface';

@Pipe({
  name: 'zGetActiveChild',
  standalone: true,
})
export class GetActiveChildPipe implements PipeTransform {
  transform(
    current: NavigationItem,
    activeItem: NavigationItem,
    currentPath: number[] | undefined,
  ): NavigationItem {
    if (!current || !activeItem || !currentPath) {
      return current;
    }

    const activeChild = current.children.find(
      child => child.id === activeItem.id,
    );

    if (activeChild && activeChild.children.length > 0) {
      const activeChild2 = activeChild.children.find(
        child => child.id === currentPath[2],
      );
      if (activeChild2) {
        return activeChild2;
      } else {
        return activeChild;
      }
    } else if (activeChild && !activeChild.children.length) {
      return activeChild;
    }

    return current;
  }
}
